export default {
  title: {
    id: 'cms_author_title',
    defaultMessage: 'Written by {name}',
  },
} as const
